export default function initStyles() {
  let bgColors = document.querySelectorAll('.js-bg-color');
  bgColors.forEach((el) => {
    el.style.backgroundColor = el.dataset.bgColor;
  });

  let objectPosition = document.querySelectorAll('.js-object-position');
  let isTouchDevice = /iPad|iPhone|iPod|Android/.test(navigator.userAgent);
  objectPosition.forEach((el) => {
    el.style.objectPosition = el.dataset.objectPosition;
    let objectPositionMobile = el.dataset.objectPositionMobile;
    if (objectPositionMobile && isTouchDevice) {
      el.style.objectPosition = objectPositionMobile;
    }
  });
}